import { resources } from "@constants/hardcoded-strings";
import { AXNUIContent, AXNUILayout } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingSuccessPageValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingSuccessPageValidationErrors = (
    isUsingThemedUI: boolean,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout
): ThemingSuccessPageValidationErrors => {
    let count = 0;
    let successTitleError = null;
    if (isUsingThemedUI && axnuiLayout.isSuccessPageEnabled) {
        if (!axnuiContent.success.successTitle) {
            count += 1;
            successTitleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        successTitleError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.successPage.tabName}
            errorCount={count}
        />
    };
};